import { TilesType } from 'types/src/types';
import { create } from 'zustand';

interface TileCreationRequestState {
  requestedType: TilesType | null;
  requestTileAddition: (type: TilesType) => void;
  clearRequest: () => void;
}

export const useCreateTileRequest = create<TileCreationRequestState>((set) => ({
  requestedType: null,
  requestTileAddition: (type) => set({ requestedType: type }),
  clearRequest: () => set({ requestedType: null }),
}));
